// extracted by mini-css-extract-plugin
module.exports = {"content":"BetGeniusScoreboard_content__rEvHC","hidden":"BetGeniusScoreboard_hidden__7MFuB","visible":"BetGeniusScoreboard_visible__wUZvf"};